module.exports = __webpack_public_path__ + "static/media/searchIcon.19bf71a6.svg";